import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';
import 'bootstrap-select';
import 'jquery-match-height';
import 'slick-carousel';
import '@fancyapps/fancybox/dist/jquery.fancybox';
import './main/base';
import './main/slider';
//import './main/breakpoint-viewer';



